import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useCallback, useMemo } from 'react';
import { getCompare, getDimensions, getReportConfig } from 'reporting-data/report/configReportGetters';
import { setCompare, setDimensions } from 'reporting-data/report/configReportSetters';
import getMeasureSizeRanges from '../../../lib/report-utils/getMeasureSizeRanges';
import { flattenPropertyGroups } from '../../../lib/reportPropertyUtils';
import useFetchPropertyOptionsForDimensionEditorDropdown from '../../dimension-editor-dropdown/config-report/useFetchPropertyOptionsForDimensionEditorDropdown';
import { disableUISelectOptionForDimensionOrBreakdownDropdown, isCompareValid } from '../../dimension-editor-dropdown/utils';
import { getIsDropdownDisabled } from '../utils';
import BreakdownEditorSelect from '../components/BreakdownEditorSelect';
import { jsx as _jsx } from "react/jsx-runtime";
const OptionWithTooltip = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      placement: "right",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.breakdown-editor-dropdown.config.disabledOption"
      }),
      disabled: !option.disabled,
      children: children
    })
  }));
};
const getCustomOptionsFormatter = dimension => options => {
  const disabledExtraBreakdownOptions = disableUISelectOptionForDimensionOrBreakdownDropdown(options, dimension);
  return flattenPropertyGroups(disabledExtraBreakdownOptions);
};
const ConfigReportBreakdownEditorDropdown = props => {
  var _getDimensions;
  const {
    report,
    dropdownFooter,
    onChange
  } = props;
  const {
    minDimensions
  } = getMeasureSizeRanges(report);
  const dimensionValue = getDimensions(report).first();
  const customBreakdownOptionsFormatter = useMemo(() => getCustomOptionsFormatter(dimensionValue), [dimensionValue]);
  const breakdownOptions = useFetchPropertyOptionsForDimensionEditorDropdown(report, customBreakdownOptionsFormatter);
  const {
    isDisabled,
    disabledReason
  } = getIsDropdownDisabled(report);
  const breakdownValue = breakdownOptions.length ? (_getDimensions = getDimensions(report)) === null || _getDimensions === void 0 ? void 0 : _getDimensions.get(1) : undefined;
  const onBreakdownChange = useCallback(({
    target: {
      value
    }
  }) => {
    let updatedReport = report;
    updatedReport = updatedReport.withMutations(mutableReport => {
      mutableReport.set('config', setDimensions(getReportConfig(mutableReport), getDimensions(mutableReport).set(1, value)));
      if (!value) {
        mutableReport.deleteIn(['config', 'dimensions', 1]);
      }
      mutableReport.set('config', setCompare(getReportConfig(mutableReport), isCompareValid(mutableReport) ? getCompare(getReportConfig(mutableReport)) : undefined));
    });
    onChange(updatedReport);
  }, [onChange, report]);
  return /*#__PURE__*/_jsx(BreakdownEditorSelect, Object.assign({}, props, {
    clearable: minDimensions < 2,
    itemComponent: OptionWithTooltip,
    dropdownFooter: dropdownFooter,
    disabled: isDisabled,
    disabledReason: disabledReason,
    options: breakdownOptions,
    value: breakdownValue,
    onChange: onBreakdownChange
  }));
};
export default ConfigReportBreakdownEditorDropdown;